import { render, staticRenderFns } from "./Group-Folder-Request.vue?vue&type=template&id=21ac3942&scoped=true&"
import script from "./Group-Folder-Request.vue?vue&type=script&lang=js&"
export * from "./Group-Folder-Request.vue?vue&type=script&lang=js&"
import style0 from "./Group-Folder-Request.vue?vue&type=style&index=0&id=21ac3942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ac3942",
  null
  
)

export default component.exports